import React, { useEffect, useState } from 'react';
import { ApiService } from '../api/ApiService';
import { UserPushNotificationStore, userStore } from '../api/AuthService';
import { UserUtils } from '../utils/UserUtils';
import { PushNotificationsService } from '../api/PushNotificationsService';
import TrainerAdvantageProgramDialog from './dialog/TrainerAdvantageProgramDialog';
import AppBroadcast from './dialog/AppBroadcast';
import PushNotificationWindow from './dialog/PushNotificationWindow';

let broadcast: any = {};

/** Toolbar dialogs that must still run on Design A Home (no visible Toolbar). */
const HomeAlerts: React.FC = () => {
  const [trainerAdvantageNotificationId, setTrainerAdvantageNotificationId] = useState<number>();
  const [showBroadcast, setShowBroadcast] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const fleetMananerCode = userStore(state => state.driver?.fleetManagerCode);

  useEffect(() => {
    const unsub = UserPushNotificationStore.subscribe(() => {
      setShowNotification(UserPushNotificationStore.getState().received);
    });
    setShowNotification(UserPushNotificationStore.getState().received);
    initNotificationCount();
    return () => {
      unsub();
    };
  }, []);

  const initNotificationCount = () => {
    if (UserUtils.isAdmin() || UserUtils.isDriverManager() || UserUtils.isInspector()) {
      return;
    }
    ApiService.checkForBroadcast('toolBar').then(it => parseBroadcastContent(it));
    ApiService.getPushNotifications('toolBar').then(it => {
      setTrainerAdvantageNotificationId(
        it.find(notification => notification.type === 'trainerAdvantage' && !notification.read)?.id
      );
    });
  };

  const parseBroadcastContent = (broadcastContent: any) => {
    if (typeof broadcastContent.message === 'undefined') return;
    broadcast = broadcastContent.message;
    if (localStorage.getItem('broadcastRead') === broadcastContent.message.id.toString()) {
      setShowBroadcast(false);
    } else {
      setShowBroadcast(true);
    }
  };

  const acceptTrainerAdvantage = () => {
    if (!trainerAdvantageNotificationId) return;
    ApiService.readPushNotification('trainerAdvantageProgramDialog', {
      id: trainerAdvantageNotificationId,
    }).then(() => initNotificationCount());
  };

  const readBroadcast = () => {
    localStorage.setItem('broadcastRead', broadcast.id.toString());
  };

  const onReadyResponse = async (response: string, additionalInfo: any) => {
    let emailList: string[] = [];
    if (fleetMananerCode === 'VFONT') {
      emailList = ['lbaker@westernexp.com'];
    } else if (
      fleetMananerCode === 'PPV' ||
      fleetMananerCode === 'VALLE' ||
      fleetMananerCode === 'VNASH' ||
      fleetMananerCode === 'VVIRG'
    ) {
      emailList = ['chawkins@westernexp.com'];
    } else if (
      fleetMananerCode === 'VLP' ||
      fleetMananerCode === 'FLP' ||
      fleetMananerCode === 'FNASH' ||
      fleetMananerCode === 'FNEREG'
    ) {
      emailList = ['jdmorris@westernexp.com'];
    }
    ApiService.sendEmail('readyForSolo', {
      to: emailList,
      subject: `Ready for solo for trainee: ${[additionalInfo]}`,
      body: `Trainer ${localStorage.getItem('username')?.toUpperCase()} has confirmed trainee ${additionalInfo} is ${
        response === 'yes' ? 'ready' : 'not ready'
      } for solo`,
    }).then(() => {});
    setShowNotification(false);
  };

  const onDeliveryResponse = (response: string) => {
    ApiService.pollResultSubmit('mondayDelivery', {
      responseId: UserPushNotificationStore.getState().responseId,
      answer: response,
    }).then(() => PushNotificationsService.removeAllNotification());
    setShowNotification(false);
  };

  const handleResponse = (response: string, type: string, additionalInfo: any) => {
    if (type === 'delivery') {
      onDeliveryResponse(response);
    } else if (type === 'ready') {
      onReadyResponse(response, additionalInfo);
    }
  };

  return (
    <>
      {showNotification ? (
        <PushNotificationWindow
          onAccept={(e: any, t: any, a: any) => handleResponse(e, t, a)}
          showModal={showNotification}
          cancel={() => setShowNotification(false)}
        />
      ) : null}
      {!!trainerAdvantageNotificationId ? (
        <TrainerAdvantageProgramDialog onAccept={() => acceptTrainerAdvantage()} />
      ) : null}
      {showBroadcast ? <AppBroadcast message={broadcast} onAccept={() => readBroadcast()} /> : null}
    </>
  );
};

export default HomeAlerts;
